// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"19b4bf23","453":"abe6e641","777":"b6a8bff6"}[chunkId] + ".chunk.js";
};